<div *ngIf="!loader">
  <div class="img-wrapper">
    <div class="lable-block">
      <span class="lable3" *ngIf="product.new">new</span>
      <span class="lable4" *ngIf="product.sale">on sale</span>
    </div>
    <div class="front">
      <a [routerLink]="['/shop/product/left/sidebar', product.title.replace(' ', '-'), product.sku]">
        <div class="tagLabel" *ngIf="product.tag !== null && product.tag !== ''" [ngClass]="getProveedorColorClass()">
          {{ product.tag }}
        </div>
        <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'"
          [lazyLoad]="ImageSrc ? ImageSrc : product.images[0]" class="img-fluid lazy-loading"
          alt="{{ product.images[0] }}" />
      </a>
    </div>
    <div class="back" *ngIf="onHowerChangeImage">
      <a [routerLink]="['/shop/product/left/sidebar/', product.title.replace(' ', '-')]">
        <img [src]="ImageSrc ? ImageSrc : product.images[1]" class="img-fluid lazy-loading"
          alt="{{ product.images[1] }}">
      </a>
    </div>
    <ul class="product-thumb-list" *ngIf="thumbnail">
      <li class="grid_thumb_img" [class.active]="ImageSrc == image.src" *ngFor="let image of product.images">
        <a href="javascript:void(0)" (mouseover)="ChangeVariantsImage(image.src)">
          <img [lazyLoad]="image.src">
        </a>
      </li>
    </ul>
    <div class="cart-info cart-wrap">
      <!-- <a href="javascript:void(0)" title="Agregar al carrito" (click)="CartModal.openModal(product)"
        *ngIf="cartModal && product.activaStock === true">
        <i class="ti-shopping-cart"></i>
      </a>
      <a href="javascript:void(0)" title="Agregar al carrito" (click)="addToCart(product)"
        *ngIf="!cartModal && product.activaStock === true && product.stock > 0">
        <i class="ti-shopping-cart"></i>
      </a> -->
      <a href="javascript:void(0)" title="Agregar a Lista de Deseos" (click)="addToWishlist(product)">
        <i class="ti-heart" aria-hidden="true"></i>
      </a>
      <a href="javascript:void(0)" title="Vista Rápida" (click)="QuickView.openModal()">
        <i class="ti-search" aria-hidden="true"></i>
      </a>
      <a href="javascript:void(0)" title="Comparar" (click)="addToCompare(product)">
        <i class="ti-reload" aria-hidden="true"></i>
      </a>
    </div>
  </div>
  <div class="product-detail">
    <div>
      <div class="text-center">
        <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
        <a [routerLink]="['/shop/product/left/sidebar/', product?.title.replace(' ', '-')]">
          <h6 style="color: black !important; font-weight: bold !important; font-size: 20px;">{{ product?.title |
            titlecase }}</h6>
        </a>
        <h3
          style="color: #212529; display: flex; justify-content: center; align-items: baseline; gap: 0.2em; flex-wrap: wrap;">
          <span style="font-size: 17px; font-weight: normal;">Desde</span>
          <span style="font-size: 30px; font-weight: bold;">
                ${{ product.tienePromocion ? (product.priceDiscount / 12 | number:'1.2-2') : (product.price / 12) | number:'1.2-2' }}
          </span>

        </h3>
        <span style="color: #212529; margin-bottom: 0px; font-weight: normal; font-size: 17px;">a 12 mensualidades
          o</span><br>
        <span style="color: #212529; margin-bottom: 0px; font-weight: normal; font-size: 17px;"> desde
          <span style="font-size: 20px; font-weight: bold;">
                ${{ product.tienePromocion ? (product.priceDiscount / 60 | number:'1.2-2') : (product.price / 60) | number:'1.2-2' }}
            </span>
          en pagos quincenales</span> <br>
        <del *ngIf="product?.tienePromocion"><span class="money"> {{ product?.price  |
            currency:currency?.currency:'symbol' }}</span></del>
        <!-- <h4 style="color: #176ec0; text-transform: none; font-weight: bold;">
            Contado a {{product.priceDiscount |currency:currency?.currency:'symbol' }}
        </h4> -->
        <h4 style="color:  #0A4385; text-transform: none; font-weight: bold;">
          Contado a {{
          product?.tienePromocion ? (product.priceDiscount     | currency:currency?.currency:'symbol' ) : (product.price
          | currency:currency?.currency:'symbol')
          }}
        </h4>
      </div>
      <div class="pt-2 text-center" *ngIf="product.envioGratis===true"> <span class="delivery-txt-blof">Envío
          Gratis</span></div>
      <div class="text-center">
        <ul class="color-variant" *ngIf="Color(product?.variants).length">
          <li [class]="color" *ngFor="let color of Color(product?.variants)" [ngStyle]="{'background-color': color}"
            (click)="ChangeVariants(color, product)">
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<app-skeleton-product-box *ngIf="loader"></app-skeleton-product-box>
<app-quick-view #quickView [product]="product" [currency]="currency"></app-quick-view>
<app-cart-modal #cartModal [product]="product" [currency]="currency" *ngIf="cartModal"></app-cart-modal>